var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeganIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.126C25.06 27.3 20.118 40 20.118 40C20.118 40 13.058 22.126 6 18",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9925 11.1548L41.8445 20.0028C42.3965 25.7428 38.0945 30.8528 32.3545 31.4068C26.7225 31.9468 21.6205 27.8308 21.0785 22.1988C20.9494 20.8596 21.0854 19.508 21.4787 18.2213C21.872 16.9346 22.5149 15.738 23.3707 14.6998C24.2265 13.6616 25.2785 12.8022 26.4665 12.1706C27.6545 11.539 28.9553 11.1476 30.2945 11.0188L39.7265 10.1108C39.8782 10.0962 40.0313 10.1116 40.177 10.1562C40.3227 10.2007 40.4583 10.2736 40.5758 10.3705C40.6934 10.4675 40.7907 10.5866 40.8622 10.7212C40.9337 10.8558 40.978 11.0031 40.9925 11.1548Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeganIcon);
export default __webpack_public_path__ + "static/media/veganIcon.7221119481e22b916acc53a203e9d981.svg";
export { ForwardRef as ReactComponent };